"use client";

import FAQItem from "@/components/FAQItem";
import { FadeIn, FadeInStaggerItem, Stagger } from "@/components/ui/motion";

const faqs = [
    {
        question: "How quickly can you build an MVP?",
        answer: "Our 'Fast MVP' service is designed to go from concept to launch in as little as 4-8 weeks. We prioritize core features to get you to market fast, then iterate based on real user feedback."
    },
    {
        question: "Do you offer post-launch support?",
        answer: "Absolutely. We provide a standard 3-month free support period for all projects to handle any bugs or minor tweaks. Beyond that, we offer flexible retainers for ongoing maintenance and feature development."
    },
    {
        question: "What is your typical budget range?",
        answer: "We work with a variety of budgets. Simple MVPs might start around $5k-$10k, while complex enterprise solutions or AI integrations can range from $25k to $100k+. We always provide a fixed-price quote after our discovery call."
    },
    {
        question: "Can you help with AI integration?",
        answer: "Yes, that's our specialty. Whether it's integrating OpenAI/LLMs, building custom chatbots, or implementing predictive analytics, we have deep expertise in making AI practical and profitable for your business."
    },
    {
        question: "Do I own the code?",
        answer: "100%. Upon final payment, you possess full intellectual property rights to the codebase, design assets, and all related documentation. No lock-ins."
    }
];

export default function FAQ() {
    return (
        <section className="py-20 bg-white border-t border-zinc-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    {/* Left side: Sticky Title & Description */}
                    <div className="lg:col-span-4">
                        <FadeIn>
                            <div className="lg:sticky lg:top-28">
                                <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-zinc-900">
                                    Common <br className="hidden lg:block" /> Questions
                                </h2>
                                <p className="mt-4 text-sm text-zinc-500 max-w-sm leading-relaxed">
                                    Everything you need to know about working with us. Feel free to reach out if you have any other questions.
                                </p>
                            </div>
                        </FadeIn>
                    </div>

                    {/* Right side: Accordion list */}
                    <div className="lg:col-span-8">
                        <Stagger className="space-y-0">
                            {faqs.map((faq, i) => (
                                <FadeInStaggerItem key={i}>
                                    <FAQItem question={faq.question} answer={faq.answer} />
                                </FadeInStaggerItem>
                            ))}
                        </Stagger>
                    </div>
                </div>
            </div>
        </section>
    );
}

// Exporting for reuse in other pages
// Removed inline FAQItem as it is now in its own file
